import { getAziendaId } from "@/lib/azienda";

/** Provider header API — impostato da AuthProvider. */
let accessTokenProvider: (() => Promise<string | null>) | null = null;
let devUserProvider: (() => string) | null = null;
let impersonateProvider: (() => string | null) | null = null;

export function setAuthHeaderProviders(opts: {
  getAccessToken?: () => Promise<string | null>;
  getDevUser?: () => string;
  getImpersonateEmail?: () => string | null;
}) {
  if (opts.getAccessToken !== undefined) accessTokenProvider = opts.getAccessToken;
  if (opts.getDevUser !== undefined) devUserProvider = opts.getDevUser;
  if (opts.getImpersonateEmail !== undefined) impersonateProvider = opts.getImpersonateEmail;
}

export async function buildAuthHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  const impersonate = impersonateProvider?.() ?? null;
  if (impersonate) {
    headers["X-Impersonate-User"] = impersonate;
  }
  const azienda = getAziendaId();
  if (azienda) {
    headers["X-Azienda"] = azienda;
  }
  if (accessTokenProvider) {
    const token = await accessTokenProvider();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      return headers;
    }
  }
  if (devUserProvider) {
    headers["X-Dev-User"] = devUserProvider();
  }
  return headers;
}
